import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchSalesOdersByDate, voidSalesOrder, fetchSalesOrders, fetchSalesOrderDetail, selectSalesOrder,
  resetCurrentSalesOrder, setSalesOrdersFilter, setValue, fetchSalesOrdersByFilter, loadsPost } from '../../actions/sales_actions';
import { fetchPosCreditsByDate, fetchPosCredits, fetchPosCreditDetail, fetchPosCreditsByFilter, voidPosOrder } from '../../actions/pos_actions';
import { setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';


import PosCredits from '../../components/Sales/posCredits';

const posCredits = reduxForm({
  form: 'posCredits',
  destroyOnUnmount: false,
})(PosCredits);

const selector = formValueSelector('posCredits');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Status = selector(state, 'Status');
  const Seller = selector(state, 'Seller');
  const ProductNum = selector(state, 'ProductNum');
  return {
    Days,
    FromDate,
    ToDate,
    Status,
    Seller,
    ProductNum,
    currentPosCredit: state.salesOrders.currentPosCredit, // x thisis after view
    posCredits: state.pos.all,
    isLoading: state.pos.isLoading,
    error: state.pos.error,

    posCreditDetail: state.pos.currentPosCreditDetail, // this is the select detail
    posCreditIsLoading: state.pos.creditDetailIsLoading,
    posCreditError: state.pos.creditDetailError,
    posCreditsFilter: state.salesOrders.salesOrdersFilter, // x

    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  fetchSalesOdersByDate,
  voidSalesOrder,
  fetchSalesOrders,
  fetchSalesOrderDetail,
  selectSalesOrder,
  resetCurrentSalesOrder,
  loadsPost,
  setSalesOrdersFilter,
  setValue,
  fetchBaseUsers,
  setDefaultOfForm,
  fetchSalesOrdersByFilter,
  fetchPosCreditsByDate,
  fetchPosCredits,
  fetchPosCreditDetail,
  fetchPosCreditsByFilter,
  voidPosOrder,
  checkPassword,
  clearCheckPassword,
})(posCredits);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/posCredits.jsx